// @mui icons
// import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import comienzoLogo from "assets/images/comienzo-logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Comienzo",
    image: comienzoLogo,
    route: "/",
    width: "180px",
    imgProps: {
      sx: {
        maxWidth: "180px",
        height: "auto",
        display: "block",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)",
        },
      },
    },
  },
  socials: [
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/comienzomy",
    },
    {
      icon: <WhatsAppIcon />,
      link: "https://wa.me/60122982460",
    },
    // {
    //   icon: <FacebookIcon />,
    //   link: "https://www.facebook.com/comienzomy",
    // },
  ],
  menus: [
    {
      name: "Visit Us",
      items: [
        {
          name: "Opening Hours",
          // href: "#",
          description: "Tue-Sun: 12PM - 10PM\nFri: 2:30PM - 10PM\nMon: Closed",
        },
        {
          name: "Location",
          href: "https://ul.waze.com/ul?venue_id=66519071.665059637.37856002",
          description: "35 Jalan Eco Ardence D U12/36D, Shah Alam",
        },
        {
          name: "Reservations",
          // href: "#",
          description: "Book a table online or call us",
        },
      ],
    },
    {
      name: "Menu",
      items: [
        { name: "Featured Dishes" },
        { name: "Mexican Fusion" },
        { name: "Italian Fusion" },
        { name: "Chef's Specials" },
      ],
    },
    {
      name: "Contact",
      items: [
        { name: "WhatsApp", href: "https://wa.me/60197562429" },
        { name: "Instagram DM", href: "https://www.instagram.com/comienzomy" },
        { name: "Email Us", href: "mailto:info@comienzo.my" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} by{" "}
      <MKTypography
        component="a"
        // href="/"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Syed Izzuddin
      </MKTypography>
      .
    </MKTypography>
  ),
};
